/* eslint-disable react/no-unused-prop-types */
import React from 'react';
import styles from './GlobalButton.module.scss';
import usePlan from '@/hooks/usePlan';

interface IProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    isDisabled?: boolean;
    backgroundGradient?: string;
    item?: number;
}

const GlobalButton = ({ children, onClick, className, isDisabled }: IProps) => {
    const opacityValue = isDisabled ? 0.35 : 1;

    const { planConfig } = usePlan();

    return (
        <button
            className={`${styles.button} ${className}`}
            onClick={onClick}
            disabled={isDisabled}
            style={{
                opacity: opacityValue,
                background: `linear-gradient(220deg, ${planConfig.colors.dark}, ${planConfig.colors.light})`,
            }}
            type="button"
        >
            {children}
        </button>
    );
};

export const CoverPlanButton = ({ children, onClick, className, backgroundGradient, item }: IProps) => {
    const getClass = () => {
        if (item === 1) return styles.btn1;
        if (item === 2) return styles.btn2;
        if (item === 3) return styles.btn3;
        if (item === 4) return styles.btn4;
        if (item === 5) return styles.btn5;
        if (item === 6) return styles.btn6;
        if (item === 10) return styles.btn10;
        if (item === 11) return styles.btn11;
        return '';
    };

    return (
        <button
            className={`${className} ${item && getClass()}`}
            onClick={onClick}
            style={{ background: backgroundGradient }}
        >
            {children}
        </button>
    );
};

export default GlobalButton;
